import React from "react";
import { Link } from "react-router-dom";

import { Section } from "@jsluna/section";
import { Card } from "@jsluna/card";
import { trackEvent } from "@jsainsburyplc/id-ui-common";

import { categoryTypes, actionTypes } from "constants/tracking";
import { getFindOutMoreLink } from "utils/urls";

import MultiMissionExplainerContent from "./MultiMissionExplainerContent";

const trackFindOutMoreClick = () => {
  trackEvent({
    category: categoryTypes.LOGIN,
    action: actionTypes.CLICK,
    label: "Find out more about My ID",
  });
};

export const MultiMissionHeader = () => (
  <Section>
    <Card className="ln-u-text-align-center">
      <MultiMissionExplainerContent />
      <Link
        onClick={trackFindOutMoreClick}
        className="ln-c-link ln-c-link--bare ln-c-link--cta ln-c-link--alpha"
        data-testid="find-out-more"
        to={getFindOutMoreLink()}
      >
        Find out more about My ID
      </Link>
    </Card>
  </Section>
);
